export enum CodeStatus {
  Established = "Established",
  Emerging = "Emerging",
}
